import DetectTouch from './detect-touch'

export default DetectTouch
